import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';

interface Props {
    text?: string;
}

export function ReadOnlyComments({ text }: Props) {
    const iconSize = 20; //TODO: Este valor ponerlo en otra pinche parte

    return (
        <div className="mb-[11px] mx-1">
            <div className="flex items-center gap-x-2">
                <ArticleRoundedIcon sx={{ height: iconSize, width: iconSize }}/>
                <label className="font-semibold min-w-[140px]">Comentarios</label>
            </div>

            <textarea
                value={text}
                disabled
                placeholder="Sin comentarios"
                className="
                    w-full h-[100px] rounded-[3px] my-1 px-2 
                    font-semibold text-gray-800 text-sm resize-none
                    border border-white focus:outline-gray-400
                    disabled:bg-white">
            </textarea>
        </div>
    );
}